import React from 'react';
import { dialogs, i18next } from '@yola/ws-sdk';
import { designSystem } from '@yola/ws-ui';
import Trigger from '../../common/components/trigger';
import dialogTypes from '../../dialogs/constants/dialog-types';
import { ELEMENT_SETTINGS_TRIGGER_ID } from '../constants/trigger-ids';

const { Icon } = designSystem;

const getElementSettingsTrigger = ({ elements, onTriggerClick, onHover, onMouseLeave }) => ({
  id: ELEMENT_SETTINGS_TRIGGER_ID,
  trigger: (
    <Trigger id={ELEMENT_SETTINGS_TRIGGER_ID}>
      <Icon glyph="settings" size="24" strokeWidth="1.3" />
    </Trigger>
  ),
  tooltip: i18next.t('Settings'),
  priority: 40,
  title: i18next.t('Settings'),
  onTriggerClick: () => {
    onTriggerClick();
    dialogs.operations.show(dialogTypes.ELEMENT_SETTINGS_DIALOG, {
      elements,
    });
  },
  onHover,
  onMouseLeave,
});

export default getElementSettingsTrigger;
